import React, { useEffect, useState, useRef } from 'react';

import { LangText } from "../zustand/dict.js";

import images from '../libs/images';
import consts from '../libs/consts';

import { clickDownS3, getFileName, regFileDoc, regFileImage } from '../utils/utils';

import Button from './Button';
import Image from './Image';

import { toast } from 'react-toastify';

export default function InputRange(props) {
    const {
        className = "",
        startText = "0",
        endText = "100",
        step = 1,
        min = 0,
        max = 100,
        value = 0,
        setValue,
        tickerValue
    } = props;

    const [width, setwidth] = useState(0);

    const calcWidth = (val) => {
        // console.log("🚀 ~ calcWidth ~ val:", val)
        let userValue = Number(val) - min;
        let range = (max - min);
        let result = ((userValue / range) * 100).toFixed(2);
        return result;
    }

    useEffect(() => {
        console.log("🚀 ~ InputRange ~ value:", min, max)
        setwidth(calcWidth(value));
    }, [value])

    return (
        <div className={`input_range_section${className ? " " + className : ""}`}>
            <p style={{ flexShrink: 0 }} className='body2 color-g300 padding_lr16'>{startText}</p>
            <div className='input_slide_box'>
                <div style={{
                    position: "absolute",
                    display: "flex",
                    background: "#D1D1D1",
                    width: "calc(100%)",
                    borderRadius: 100,
                    height: 6,
                }}>
                    <div style={{
                        position: "absolute",
                        background: "#A67CFF",
                        width: `${width}%`,
                        borderRadius: 100,
                        height: 6,
                        // transition: "width .2s"
                    }} />
                    <div style={{
                        position: "absolute",
                        background: "#A67CFF",
                        width: 20,
                        height: 20,
                        top: "calc(50% - 10px)",
                        borderRadius: 10,
                        border: "1px solid white",
                        left: `calc(${width}% - 10px)`,
                        // transition: "left .2s"
                    }} />

                    {(tickerValue || tickerValue == 0) && <div style={{
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: 13,
                        width: 42,
                        height: 24,
                        top: -35,
                        borderRadius: 10,
                        background: "#A67CFF",
                        border: "1px solid white",
                        left: `calc(${width}% - 21px)`,
                        // transition: "left .2s"
                    }}>
                        {tickerValue}
                    </div>}
                </div>
                <input
                    type="range"
                    value={value}
                    min={min}
                    max={max}
                    step={step}
                    onChange={(e) => {
                        if (setValue) setValue(e.target.value)
                    }} />
            </div>
            <p style={{ flexShrink: 0 }} className='body2 color-g300 padding_lr16'>{endText}</p>
        </div>
    )
}